import { useLocale } from 'next-intl'
interface RenderVideoProps {
  url: string
  playbackToken?: string
  iframeRef: React.RefObject<HTMLIFrameElement | null>
  onEnded: () => void
}

const TrailerCarouselVideo = ({ url, playbackToken, iframeRef, onEnded }: RenderVideoProps) => {
  const locale = useLocale()
  if (playbackToken) {
    const localeShort = locale.replace(/-.+$/, '')
    return (
      <iframe
        id="trailer_video_iframe"
        ref={iframeRef}
        src={`https://showroom.one.blendvision.com/embed?token=${playbackToken}&lang=${localeShort}`}
        className="size-full rounded-none object-cover md:rounded-[5px] lg:rounded-[15px]"
        allow="autoplay; encrypted-media; clipboard-write; object_fit:fill"
        allowFullScreen
        title="trailer video iframe"
      />
    )
  } else if (url) {
    return (
      <video
        autoPlay
        muted
        playsInline
        onEnded={onEnded}
        controls={true}
        src={url}
        className="h-full w-full object-cover"
      />
    )
  } else {
    return null
  }
}
export default TrailerCarouselVideo
